import './../css/video.scss'
loadjs.ready(['jquery', 'core', 'videojs'], function() {
    $body.on('slide', '.slide', function () {
        var $el = $(this);
        var $slider = $el.closest('.slider');
        var $modal = $el.closest('.modal');
        var $sliderArrows = $slider.find('.slider-arrows');
        var isVideoSlide = $el.is('.video-slide');
        var player = $el.data('player');

        if (isVideoSlide) {
            if (!player) {
                var $img = $el.find('img').css({opacity: 0});
                var $video = $el.find('video');
                var onFullScreenChangeCallback = function () {
                    if (document.fullscreenElement || player.isFullscreen()) {
                        $slider[0].slider.toggleEvents(false);
                    } else {
                        $slider[0].slider.toggleEvents(true);
                    }
                }

                player = videojs($video[0], {
                    autoplay: false,
                    muted: true,
                    loop: true,
                    preload: 'auto',
                    responsive: false,
                    playsinline: true,
                    disablePictureInPicture: true,
                    nativeControlsForTouch: videojs.browser.IS_ANDROID,
                    controls: true,
                    poster: $img[0].currentSrc,
                    children: {
                        posterImage: true,
                        loadingSpinner: true,
                        controlBar: {
                            fullscreenToggle: true,
                            remainingTimeDisplay: true,
                            playToggle: false,
                            volumePanel: false,
                            durationDisplay: false,
                            subtitlesButton: false,
                            captionsButton: false,
                            subsCapsButton: false,
                            audioTrackButton: false,
                            pictureInPictureToggle: false,
                            currentTimeDisplay: false,
                        }
                    },
                    hls: {
                        enableLowInitialPlaylist: false,
                        limitRenditionByPlayerDimensions: false,
                        bandwidth: 3000000
                    }
                });
                $video = $(player.el()).find('video');
                player.one('loadedmetadata', function () {
                    $img.animate({
                        opacity: 0,
                    }, 400, function() {
                        $img.remove();
                    })
                    if ($slider[0].slider.currentSlide() === $el.index()) {
                        player.playPromise = player.play();
                    }
                })
                player.on('play', function () {
                    $sliderArrows.attr('style', 'visibility: hidden; opacity: 0;');
                    $el.removeClass('is-paused');
                })
                player.on('pause', function () {
                    $sliderArrows.removeAttr('style');
                    $el.addClass('is-paused');
                })

                if (!videojs.browser.IS_ANDROID) {
                    var PlayToggle = videojs.getComponent('playToggle');
                    var toggle = new PlayToggle(player);
                    toggle.addClass('main-toggle');
                    player.addChild(toggle);

                    player.on('fullscreenchange', onFullScreenChangeCallback)
                } else {
                    $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange', onFullScreenChangeCallback)
                }

                player.src([
                    {type: 'application/x-mpegURL', src: $video.data('hls')},
                    {type: 'application/dash+xml', src: $video.data('dash')}
                ])

                $el.data('player', player);
            }
        }

        $el.siblings('.video-slide:not(.is-paused)').each(function () {
            var s = $(this).data('player');
            if (s) {
                if (s.playPromise) {
                    s.playPromise.then(function() {
                        s.pause();
                        s.playPromise = null;
                    })
                } else {
                    s.pause();
                }
            }
        });
        if ($modal.length) {
            $modal.on('modal:hide', function () {
                var $slide = $(this).find('.video-slide');
                if ($slide.length && $slide.data('player') && !$slide.data('player').paused()) {
                    var s = $slide.data('player')
                    if (s.playPromise) {
                        s.playPromise.then(function() {
                            s.pause();
                            s.playPromise = null;
                        })
                    } else {
                        s.pause();
                    }
                }
            })
        }

    });
});